<template>
  <div class="home">
    <HeaderComponent v-if="!$route.meta.hideHeader" />
    <router-view/>
    <footerComponent v-if="!$route.meta.hideFooter" />
  </div>
</template>

<script>
import HeaderComponent from '@/components/Header.vue';
import FooterComponent from '@/components/Footer.vue';
/* eslint-disable no-console */
export default {
  name: 'App',
  components: {
    HeaderComponent,
    FooterComponent,
  },
};
</script>

<style src="@/assets/css/style.css"></style>
